import { Composer } from "vue-i18n";
import type {FetchContext} from "ofetch";
import {Device} from "@nuxtjs/device/runtime/types";



export default defineNuxtPlugin(({ $i18n, $device }) => {
  const config = useRuntimeConfig();
  const generalStore = useGeneralStore();
  const nuxtApp = useNuxtApp();
  const localePath = useLocalePathPolyfill();
  const currentLanguageCode = ($i18n as Composer).locale.value;
  const fatalErrors = [500, 403, 404]
  const { uidCookie } = useCookiesService();


  function onResponseError(context: FetchContext) {
    if (
        !context?.options?.skipErrors?.includes(context?.response!.status) &&
        fatalErrors.includes(context?.response!.status)
    ) {
      nuxtApp.runWithContext(() => {
        if (context.response?.status === 401) {
          generalStore.setUserInfo(null, false);
          return navigateTo(localePath("/"));
        }
        return showError({
          statusCode: context.response?.status,
          statusMessage:
              context.response?._data?.errors?.[0]?.message || "Error",
          fatal: true,
        });
      });
    }
  }
  const defaultLangCode = (generalStore.languages || []).find(
      (lang) => lang.is_default,
  )?.slug;

  const setConfig = () => ({
    apiBase: config.public.apiBase as string,
    onResponseError,
    cacheVersions: generalStore.cacheVersions,
    defaultLangCode,
    authToken: generalStore.getToken,
    currentLanguageId: generalStore.getCurrentLanguage(
        currentLanguageCode as string,
    )?.id,
    defaultLanguageId: generalStore.getDefaultLanguage?.id,
    addCurrentTranslation,
    currentLanguageCode,
    isDesktop: ($device as Device).isDesktop,
    uid: uidCookie.value || ''
  });
  const api = new ApiInstance(setConfig);

  return {
    provide: {
      api: api.modules,
    },
  };
});
